<template>
  <div class="all-links">
    <div
      id="links-reference"
      @mouseover="setIsHoverActive(true)"
      @mouseleave="setIsHoverActive(false)"
      class="all-link" 
      :class="{'all-link-active': this.$route.meta.active == 1}"
      v-if="(userCan('ticket_system_show')
      || userCan('organisation_read_all') || userCan('role_read_all')
      || userCan('user_read_all') || userCan('container_type_read_all')
      || userCan('container_platform_type_read_all') || userCan('failure_reason_read_all')
      || userCan('breakdowns_type_read_all') || userCan('payment_category_name_read_all')
      || userCan('work_order_cancelation_reason_read_all') || back_office)"
    >
      <div class="link-flex">
        {{ getByHotSpotRouteTitleMenu('directories-menu') }}
        <div v-if="isActiveHotSpot('directories-menu')?.id" class="hotspot"
        @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
            hoverEvent: $event,
            tooltipText: currentTooltipForHotSpot('directories-menu'),
            tooltipPosition: 'right'
          })" 
        @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
        Новое
        </div>
      </div>
      <img
        class="chevron-img normal"
        src="@/assets/restyle/images/menu/chevron.svg"
        alt=""
      />
      <img
        class="chevron-img hover"
        src="@/assets/restyle/images/menu/chevron-green.svg"
        alt=""
      />
      <reference :back_office="back_office" class="active-block" />
    </div>
    <div
      id="links-talons"
      @mouseover="setIsHoverActive(true)"
      @mouseleave="setIsHoverActive(false)"
      class="all-link" 
      :class="{'all-link-active': this.$route.meta.active == 12}"
      v-if="userCan('ticket_system_show')"
    >
      <div class="link-flex">
        {{ getByHotSpotRouteTitleMenu('talons') }}
        <div v-if="isActiveHotSpot('talons')?.id" class="hotspot"
        @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
            hoverEvent: $event,
            tooltipText: currentTooltipForHotSpot('talons'),
            tooltipPosition: 'right'
          })" 
        @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
        Новое
        </div>
      </div>
      <img
        class="chevron-img normal"
        src="@/assets/restyle/images/menu/chevron.svg"
        alt=""
      />
      <img
        class="chevron-img hover"
        src="@/assets/restyle/images/menu/chevron-green.svg"
        alt=""
      />
      <talonItems :back_office="back_office" class="active-block" />
    </div>
    <div
      id="links-inventory"
      @mouseover="setIsHoverActive(true)"
      @mouseleave="setIsHoverActive(false)"
      class="all-link" 
      :class="{'all-link-active': this.$route.meta.active == 2}"
      v-if="userCan('container_platform_card_read_all') || userCan('container_card_read_all')"  
    >
        <div class="link-flex">
          {{ getByHotSpotRouteTitleMenu('inventory-menu') }}
          <div v-if="isActiveHotSpot('inventory-menu')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('inventory-menu'),
              tooltipPosition: 'right'
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
        </div>
      <img
        class="chevron-img normal"
        src="@/assets/restyle/images/menu/chevron.svg"
        alt=""
      />
      <img
        class="chevron-img hover"
        src="@/assets/restyle/images/menu/chevron-green.svg"
        alt=""
      />
      <inventory class="active-block" />
    </div>
    <div 
      id="links-fact"
      @mouseover="setIsHoverActive(true)"
      @mouseleave="setIsHoverActive(false)"
      class="all-link" 
      :class="{'all-link-active': this.$route.meta.active == 3}"
      v-if="userCan('monitoring_read') || userCan('show_online_monitoring_photo') || userCan('vehicle_read_all') || back_office"
    >
        <div class="link-flex">
          {{ getByHotSpotRouteTitleMenu('fact-menu') }}
          <div v-if="isActiveHotSpot('fact-menu')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('fact-menu'),
              tooltipPosition: 'right'
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
        </div>
      <img
        class="chevron-img normal"
        src="@/assets/restyle/images/menu/chevron.svg"
        alt=""
      />
      <img
        class="chevron-img hover"
        src="@/assets/restyle/images/menu/chevron-green.svg"
        alt=""
      />
      <fact class="active-block" :back_office="back_office" />
    </div>
    <div 
      id="links-logistic"
      class="all-link" 
      :class="{'all-link-active': this.$route.meta.active == 4}" 
      v-if="userCan('show_logistic_menu')"
    >
        <div class="link-flex">
          {{ getByHotSpotRouteTitleMenu('logistic-menu') }}
          <div v-if="isActiveHotSpot('logistic-menu')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('logistic-menu'),
              tooltipPosition: 'right'
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
        </div>
      <img
        class="chevron-img normal"
        src="@/assets/restyle/images/menu/chevron.svg"
        alt=""
      />
      <img
        class="chevron-img hover"
        src="@/assets/restyle/images/menu/chevron-green.svg"
        alt=""
      />
      <logistic class="active-block" />
    </div>
    <div 
      v-if="userCan('show_reports_menu')"
      id="report-work-drivers"
      class="all-link" 
      :class="{'all-link-active': this.$route.meta.active == 6}" 
    >
        <div class="link-flex">
          {{ getByHotSpotRouteTitleMenu('reports-menu') }}
          <div v-if="isActiveHotSpot('reports-menu')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('reports-menu'),
              tooltipPosition: 'right'
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
        </div>
      <img
        class="chevron-img normal"
        src="@/assets/restyle/images/menu/chevron.svg"
        alt=""
      />
      <img
        class="chevron-img hover"
        src="@/assets/restyle/images/menu/chevron-green.svg"
        alt=""
      />
      <reports class="active-block"/>
    </div>
    <div 
      v-if="userCan('notification_show')"
      id="notifications"
      class="all-link" 
      :class="{'all-link-active': this.$route.meta.active == 8}" 
    >
        <div class="link-flex">
          {{ getByHotSpotRouteTitleMenu('notifications') }}
          <div v-if="isActiveHotSpot('notifications')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('notifications'),
              tooltipPosition: 'right'
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
        </div>
      <img
        class="chevron-img normal"
        src="@/assets/restyle/images/menu/chevron.svg"
        alt=""
      />
      <img
        class="chevron-img hover"
        src="@/assets/restyle/images/menu/chevron-green.svg"
        alt=""
      />
      <notifications class="active-block"/>
    </div>
    <div 
      v-if="userCan('contract_management_show')"
      id="contract-block"
      class="all-link" 
      :class="{'all-link-active': this.$route.meta.active == 10}" 
    >
        <div class="link-flex">
          {{ getByHotSpotRouteTitleMenu('contract-block') }}
          <div v-if="isActiveHotSpot('contract-block')?.id" class="hotspot"
          @mouseenter="$store.dispatch('tooltip_store/SET_VIEW_TOOLTIP', {
              hoverEvent: $event,
              tooltipText: currentTooltipForHotSpot('contract-block'),
              tooltipPosition: 'right'
            })" 
          @mouseleave="$store.dispatch('tooltip_store/CLEAR_VIEW_TOOLTIP');">
          Новое
          </div>
        </div>
      <img
        class="chevron-img normal"
        src="@/assets/restyle/images/menu/chevron.svg"
        alt=""
      />
      <img
        class="chevron-img hover"
        src="@/assets/restyle/images/menu/chevron-green.svg"
        alt=""
      />
      <contractBlock class="active-block"/>
    </div>
  </div>
</template>

<script>
import reference from "./blocks/reference";
import talonItems from "./blocks/talonItems.vue";
import inventory from "./blocks/inventory";
import fact from "./blocks/fact";
import logistic from "./blocks/logistic";
import reports from "./blocks/reports.vue";
import notifications from "./blocks/notifications.vue";
import contractBlock from "./blocks/contractBlock.vue";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: {
    reference,
    inventory,
    fact,
    logistic,
    reports,
    notifications,
    contractBlock,
    talonItems
  },
  computed: {
    ...mapGetters({
      userCan: "user/userCan",
      getByHotSpotRouteTitleMenu: "hotspots/getByHotSpotRouteTitleMenu",
      allListActiveHotSpots: "hotspots/allListActiveHotSpots",
    }),
    back_office() {
      return this.userCan('technical_department_root') || Boolean(process.env.VUE_APP_LOCAL_DEV);
    }
  },
  methods: {
    ...mapMutations({
      setIsHoverActive: 'hoverStateTopMenu/setIsHoverActive'
    }),
    isActiveHotSpot(menu) {
      const rusNameMenu = this.getByHotSpotRouteTitleMenu(menu)
      const result = this.allListActiveHotSpots.find(item => item.menu === rusNameMenu);
      return result;
    },
    currentTooltipForHotSpot(menu) {
      const hotSpot = this.isActiveHotSpot(menu);
      if (Object.entries(hotSpot).length &&  hotSpot.tooltip) {
        return hotSpot.tooltip
      } 
      return ''
    }
  }
};
</script>

<style lang="scss" scoped>
.chevron-img {
  width: 10px;
  height: 6px;
  flex: 0 0 auto;
}

.all-links {
  display: flex;
  height: 100%;
  gap: 20px;
}

.all-link {
  height: 52px;
  display: flex;
  align-items: baseline;
  position: relative;
  padding: 14px 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  cursor: pointer;

  & img {
    margin-left: 10px;
  }

  .hover {
    display: none;
    transform: rotate(180deg);
  }

  .active-block {
    display: none;
  }

  &-active {
    color: #44ff8f;

    .normal {
      display: none;
    }

    .hover {
      display: initial;
      transform: rotate(0);
    }
  }

  &:hover {
    color: #44ff8f;

    .normal {
      display: none;
    }

    .hover {
      display: initial;
      transform: rotate(180deg);
    }

    .active-block {
      display: grid;
    }
  }
}

.link-flex {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
</style>